import { IContent } from '../../core/services/locations.service';

export interface LocationsState {
  provinces: IContent[];
  districts: IContent[];
  sectors: IContent[];
  cells: IContent[];
  villages: IContent[];
  loading: boolean;
  error: string | null;
}

export const initialLocationsState: LocationsState = {
  provinces: [],
  districts: [],
  sectors: [],
  cells: [],
  villages: [],
  loading: false,
  error: null,
};
